/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import No from './No/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let Disabled = React.lazy(() => import('./Disabled/index'))
let Enabled = React.lazy(() => import('./Enabled/index'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Profile/Content/TwoFactorAuth/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let accountActiveMfaTypeValueData = fromData.useDataFormat({ viewPath,
context: 'account',
path: 'active_mfa_type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: accountActiveMfaTypeValueData,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginTop={0}
 marginBottom={0}
 text="Two-factor authentication"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 text="Gain an extra layer of security when logging in with two-factor authentication."
/>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Enabled'}>
<Enabled
{...childProps}
  viewPath={`${viewPath}/Enabled`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Disabled'}>
<Disabled
{...childProps}
  viewPath={`${viewPath}/Disabled`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}